import { render } from "./EditDonationPaymentDetails.vue?vue&type=template&id=e3985cb0"
import script from "./EditDonationPaymentDetails.vue?vue&type=script&lang=js"
export * from "./EditDonationPaymentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__